export const appendUrlParameters = (url, keyValuePairs) => {
  var prefix = '?';
  for (var i = 0; i < keyValuePairs.length; i++) {
    if (keyValuePairs[i][1] != null) {
      url = `${url}${prefix}${keyValuePairs[i][0]}=${keyValuePairs[i][1]}`;
      prefix = '&';
    }
  }
  return url;
};
